/**
 * 全局配置文件
 * Created by gentean on 2015/10/6.
 */
console.log(SERVER)
function CONF() {
  this.api = SERVER || 'https://dev-heimdall.xiaomai5.com/';
  this.appId = APPID || 'wx2651b28dc21cea1b'
}
window.CONFG = new CONF();

export default new CONF();

console.log(window.CONFG)
